import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctors-next-register-send',
  templateUrl: './doctors-next-register-send.component.html',
  styleUrls: [
    './doctors-next-register-send.component.css',
    '../style/index.css',
    '../style/verification-page.css',
  ],
})
export class DoctorsNextRegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  constructor(title: Title) {
    super();
    title.setTitle('Verify Email');
  }

  get baseLink() {
    return environment.apps[this.clientId].appUrl;
  }

  get resendEmailLink() {
    return location.href.replace('register-send', 'register-resend');
  }
  ngOnInit(): void {}
}
